import PropTypes from 'prop-types';
import { extendObservable } from 'mobx';
import { apiCall } from '../../../API';
import { RULE_REC_TYPE } from '../../../constants';
import ConcurrencyPopUpStore from '../../ConcurrencyPopUpStore';
import FlagStore from '../../FlagStore';
import CategoriesSectionStore from '../CategoriesSectionStore';
import PolicyTableStore from '../PolicyTableStore';
import RedirectRulesOptionsStore from './RedirectRulesOptionsStore';
import RedirectMatchCriteriaStore from './RedirectMatchCriteriaStore';
import BoolStore from '../../helpers/BoolStore';

export default class RedirectRulesStore {
    static PATH = '/console/redirect-rules'
    static PUBLIC_PATH = '/api/v3/redirect-rules'

    static PropType = PropTypes.shape({
        policyTable: PolicyTableStore.PropType.isRequired,
        showNoBrowsingRoleEnabledAlert: BoolStore.PropType,
        showReminderAlert: BoolStore.PropType,
    });

    constructor(data = {}) {
        extendObservable(this, /** @class RedirectRulesStore */{
            policyTable: new PolicyTableStore({
                apiList: apiCall(`${RedirectRulesStore.PATH}/list`),
                apiChangePriorities: apiCall(`${RedirectRulesStore.PATH}/rearrange`),
                modalSections: {
                    options: new RedirectRulesOptionsStore(),
                    categories: new CategoriesSectionStore(),
                    matchCriteria: new RedirectMatchCriteriaStore(),
                },
                concurrencyPopUpStore: new ConcurrencyPopUpStore({
                    apiVersionedUpdate: apiCall(`${RedirectRulesStore.PATH}/versioned/update`),
                    apiUpdate: apiCall(`${RedirectRulesStore.PATH}/update`),
                    apiCreate: apiCall(`${RedirectRulesStore.PATH}/create`),
                    apiVersionedDelete: apiCall(`${RedirectRulesStore.PATH}/versioned/delete`),
                    apiDelete: ({ id }) => apiCall(`${RedirectRulesStore.PATH}/delete/${id}`)(),
                    type: RULE_REC_TYPE.REDIRECT_RULES,
                }),
            }),
            aboutExpanded: new FlagStore(true),
            showNoBrowsingRoleEnabledAlert: new BoolStore(false),
            showReminderAlert: new BoolStore(false),
        }, data);
    }
}
